/**
 * Case-insensitive comparison function
 * @param {string} optionStr string which is used for filtering
 * @param {string} filter filter string
 * @returns {boolean} true if string mathes the filter string
 */
export function checkFilterMatch(optionStr, filter) {
    const o = optionStr ? optionStr.toLocaleLowerCase() : '';
    const f = filter.toLocaleLowerCase();
    return o.startsWith(f);
}

/**
 * Check if string contain printable character
 * @param {string} str 
 * @returns {boolean}
 */
export function isPrintableCharacter(str) {
    return str.length === 1 && !!str.match(/\S| /);
}
